import brightnessByColor from 'src/utils/colors';

export const getGrauByScore =
  (grauMatrizRisco = []) =>
  (score) => {
    const levels = grauMatrizRisco.filter((level) => level.grauRisco);
    for (let i = 0; i < levels.length; i++) {
      const { de, ate, grauRisco } = levels[i];
      if (score >= de && score < ate) return grauRisco;

      if (i === 0 && score < de) return grauRisco;

      if (i === levels.length - 1 && score >= ate) return grauRisco;
    }
    return null;
  };

export const getColorByScore = (grauMatrizRisco = []) => {
  const getGrau = getGrauByScore(grauMatrizRisco);
  return (score) => getGrau(score)?.cor ?? '#fff';
};

export const defineBgColorByScore = (grauMatrizRisco) => {
  const getColor = getColorByScore(grauMatrizRisco);
  const getColorObj = (cor) => ({
    background: cor,
    '--bs-table-bg': cor,
    '--bs-table-bg-type': cor,
    color:
      brightnessByColor(cor) / 2 > 125
        ? '#000000' /* Black */
        : '#ffffff' /* White */,
    textAlign: 'center',
    border: '1px solid #dee2e6',
  });

  return (score) => getColorObj(getColor(score));
};
